module.exports = "https://cdn.thelire.com/ins/resource/private@3x.0bdee0327d6214cdd3a72d5c9ba7c4db.png";